import { IContext } from "./IContext"

export interface IList<T>{
    readonly list: T[]
}

export interface IEntity<T>{
    readonly item: T
}

export interface IRouterId{
    readonly id: string
}

export const isLive = (currentLive: IContext["currentLive"]) => currentLive && !Array.isArray(currentLive) && Object.keys(currentLive).length > 0

export const openTwitch = (username: string) => window.open("https://www.twitch.tv/" + username, "_blank")